import React from 'react';

import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { pathByRouteName } from '../../../../util/routes';
import { useIntl, FormattedMessage } from '../../../../util/reactIntl';
import { ExternalLink, FieldCheckbox } from '../../../../components';

import css from './TermsAndConditions.module.css';

const TermsAndConditions = () => {
  const routes = useRouteConfiguration();
  const intl = useIntl();

  const privacyPolicyPath = pathByRouteName('PrivacyPolicyPage', routes);
  const termsOfServicePath = pathByRouteName('TermsOfServicePage', routes);

  const privacyLink = (
    <ExternalLink className={css.privacyLink} href={privacyPolicyPath}>
      <FormattedMessage id="RequestPriceForm.termsAndConditionsPrivacyLinkText" />
    </ExternalLink>
  );
  const termsLink = (
    <ExternalLink className={css.termsLink} href={termsOfServicePath}>
      <FormattedMessage id="RequestPriceForm.termsAndConditionsTermsLinkText" />
    </ExternalLink>
  );

  return (
    <div className={css.root}>
      <FieldCheckbox
        labelClassName={css.label}
        textClassName={css.text}
        checkboxWrapperClassName={css.checkboxWrapper}
        id="termsAndConditions"
        name="termsAndConditions"
        value="termsAndConditionsAccepted"
        label={intl.formatMessage(
          {
            id: 'RequestPriceForm.termsAndConditionsAcceptText',
          },
          {
            privacyLink,
            termsLink,
          }
        )}
      />
    </div>
  );
};

export default TermsAndConditions;
